import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

const ReactionsIcon = styled(Box).attrs(() => ({
  mr: 2,
  'aria-hidden': 'true',
}))``;

export default ReactionsIcon;
